class ArtBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.before = this.querySelector("[data-art-ba-before]");
    this.handle = this.querySelector("[data-art-ba-handle]");
    this.range = this.querySelector("[data-art-ba-range]");
    if (!this.before || !this.handle || !this.range) return;
    this._onInput = () => this.set(this.range.value);
    this.range.addEventListener("input", this._onInput);
    this._onKey = (e) => {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      const next = Number(this.range.value) + (e.key === "ArrowRight" ? 4 : -4);
      this.range.value = String(Math.max(0, Math.min(100, next)));
      this.set(this.range.value);
    };
    this.handle.addEventListener("keydown", this._onKey);
    this.set(this.range.value);
  }
  disconnectedCallback() {
    if (this.range && this._onInput) this.range.removeEventListener("input", this._onInput);
    if (this.handle && this._onKey) this.handle.removeEventListener("keydown", this._onKey);
  }
  set(value) {
    const pct = Math.max(0, Math.min(100, Number(value)));
    this.before.style.width = pct + "%";
    this.handle.style.left = pct + "%";
    this.handle.setAttribute("aria-valuenow", String(Math.round(pct)));
  }
}
if (!customElements.get("art-before-after")) {
  customElements.define("art-before-after", ArtBeforeAfter);
}
